import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Debug from 'debug'

import { setEnableClientEvents } from '@jotta/grpc-connect-client/clientEvent'
import { useUsername } from '@jotta/grpc-connect-client/customer'
import { useCookieCategoryConsent } from '@jotta/ui/cookieConsent'

const debug = Debug('jotta:webapp:tracking')

declare global {
  // eslint-disable-next-line no-var
  var dataLayer: any[] | undefined
}

export function useTracking() {
  const location = useLocation()
  const statisticConsent = useCookieCategoryConsent('statistic')
  const username = useUsername()

  useEffect(() => {
    const paq = window._paq
    if (paq) {
      debug('Track page view to %s', location.pathname)
      paq.push(['setCustomUrl', location.pathname])
      paq.push(['trackPageView'])
    }
  }, [location])

  useEffect(() => {
    const paq = window._paq
    if (paq && username) {
      paq.push(['setUserId', username])
    }
  }, [username])

  useEffect(() => {
    const canSendClientEvents = Boolean(statisticConsent && username)
    setEnableClientEvents(canSendClientEvents)
  }, [statisticConsent, username])
}
